import { BaseClass } from '../base-class';
import { Role } from '../role';
import { UserDetail } from './user-detail';
import { Client } from '../client';
import { BaseRepository } from '@interfaces/base-repository';
import { Site } from '@classes/site';
import { Feature } from '@classes/feature';

export class User extends BaseClass implements BaseRepository {
  username: string;
  email: string;
  isActive: boolean;
  role: Role;
  detail: UserDetail;
  clients: Client[];
  sites: Site[];
  allSites: boolean;
  features?: Feature[];

  lastLogonOn: Date;
  hasPassword: boolean;

  constructor();
  constructor(
    username: string,
    email: string,
    role: Role,
    clients: Client[],
    sites: Site[],
    allSites: boolean,
    firstname?: string,
    lastname?: string,
    phone?: string,
  );
  constructor(
    username?: string,
    email?: string,
    role?: Role,
    clients?: Client[],
    sites?: Site[],
    allSites?: boolean,
    firstname?: string,
    lastname?: string,
    phone?: string,
  ) {
    super();
    this.username = this.trim(username);
    this.email = this.trim(email).toLowerCase();
    this.role = role || null;
    this.clients = clients || [];
    this.sites = sites || [];
    this.allSites = allSites;
    this.detail = new UserDetail(firstname, lastname, phone);
  }

  static fromObject(object: User): User {
    return Object.assign(new User(), {
      ...object,
      clients: object.clients?.map((o) => Client.fromObject(o)),
      sites: object.sites?.map((o) => Site.fromObject(o)),
    });
  }

  get display(): string {
    return this.username;
  }

  doesInclude(value: string): boolean {
    return this.some([this.username], value);
  }
}
